import React from "react";
import "./inicio.scss";
import Label from "../../components/label";
import { Typography } from "@material-ui/core";
//Componentes
import Header from "./header";
import Loading from "../../components/loading";

const StatusRegistro = {
  Ativo: 1,
  Cancelado: 0
}

class Inicio extends React.Component {
  constructor() {
    super();
    this.state = { Welcome: true, QuestionIndex: 0, width: 0, height: 0 };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    const { match, getDadosFormularioAction, history } = this.props;
    const params = match.params;

    if (params && params.id) {
      getDadosFormularioAction(params.id, history);
    } else {
      history.push("/");
    }
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  render() {
    const { history } = this.props;
    const { dados, loadingFormulario } = this.props.formulario;
    if (loadingFormulario) {
      return <Loading />;
    }
    return (
      <section className="container w-100">
        {dados && (
          <div className="col">
            <Header title={"Bem-vindo"} />
            <Label type="title" label={"Seja bem-vindo " + dados.NomeGerente} />
            <Typography className="texto-informativo">
              {dados.Status === StatusRegistro.Ativo ? ("Deseja começar o preenchimento do formulário de " +
                dados.Nome +
                " para " +
                dados.NomeCliente +
                " ?") : "O cadastro deste cliente foi cancelado, aguarde outra solicitação para o cadastro correto."}
            </Typography>
            {dados.Status === StatusRegistro.Ativo && (
               <div className="botao-confirmar-container">
               <button
                 onClick={() =>
                   history.push("/kyc/formulario/" + dados.IdPessoa)
                 }
                 className="botao-confirmar-inicio mt-25"
               >
                 Sim
               </button>
             </div>
            )}           
          </div>
        )}
      </section>
    );
  }
}
export default Inicio;
